import type { SVGProps } from "react";
import { forwardRef } from "react";
import type { Ref } from "react";
interface SVGRProps {
  title?: string;
  titleId?: string;
}
const SvgDog = (
  { title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    aria-hidden="true"
    focusable="false"
    ref={ref}
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M10.37 7.443v.01M18.145 15.736c.31.79 1.366 2.6 3.105 3.532"
    />
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M13.804 8.797c-.47 2.492-.905 8.246 3.33 7.72 0 0 3.148-1.843 1.406-8.224-1.065-3.897-3.613-5.131-6.038-4.923l-2.138.169c-2.787.185-3.17 2.492-3.013 3.479L2.75 8.972c.04 1.71.838 5.05 3.705 4.723 2.866-.325 3.8-.57 3.909-.651.57 1.75.314 4.883-1.181 7.337 1.209.366 3.722.643 5.99-.373"
    />
  </svg>
);
const ForwardRef = forwardRef(SvgDog);
export default ForwardRef;
